<template>
  <div class="form-group centix-vue-selectinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
    <form-label :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
      <span class="holder-span" :class="inputCssClass">
        <select-input v-model="localvalue" @value-changed="valueChanged" :is-enabled="isEnabled" :required="required" :options="options" class="input-item"/>
      </span>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>
<script>
import selectinput from 'components/Input/SelectInput.vue';
import FormMixin from './formitem.js';

export default {
  mixins: [FormMixin],
  components: {
    'select-input': selectinput
  },
  props: {
    value: {
      required: true
    },
    options: {
      required: true
    }
  },
  data () {
    return {
      formType: 'select',
      localvalue: null
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      this.emitFormChange();
    },
    valueChanged (val) {
      this.$log('value changed from inner component', val);
      if (val !== this.value) {
        this.raiseValueChanged(val);
      }
    },
    clearForm() {
      this.raiseValueChanged('');
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-selectinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
